'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.createAction = createAction;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAction(actionName) {
	var actions = {
		STARTED: actionName + '_STARTED',
		COMPLETED: actionName + '_COMPLETED',
		FAILED: actionName + '_FAILED'
	};
	return (0, _extends3.default)({}, actions, {
		TYPES: [actions.STARTED, actions.COMPLETED, actions.FAILED]
	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/utils/helper.js
 ** module id = 1122
 ** module chunks = 0
 **/